module.exports = __webpack_public_path__ + "static/img/jinritoutiao.108d1832.png";